function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".poster-title-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "poster-title-1",
  d: "M47.81.71H.81v46H14.65V60.57H47.81ZM7.7,7.73H26v3.56H7.7Zm0,5.93H26v3.55H7.7Zm0,5.92H26v3.56H7.7ZM40.92,42H7.7V38.44H40.92V42Zm0-5.93H7.7V32.51H40.92v3.56Zm-.11-17.86v7.61l-4.56-1.64-4.56,1.64V18.21a7.34,7.34,0,1,1,9.12,0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "poster-title-1",
  d: "M1.85,50.3l9.24,9.23V50.3Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "poster-title-1",
  d: "M36.25,8.69A3.78,3.78,0,1,0,40,12.47,3.79,3.79,0,0,0,36.25,8.69Z"
});

var SvgTitle = function SvgTitle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 48.74 61.61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/title.6f3ec89d.svg";
export { ForwardRef as ReactComponent };